import { useSelector } from 'react-redux';
import { Typography, Box } from '@material-ui/core';

import Button from '../../Button/Button.component';

import { useInactivation } from 'hooks/patient.hook';

const InactivatePatientConfirmation = () => {
  const { _id } = useSelector(state => state.patient.data);

  const { mutate, isLoading } = useInactivation();

  const onConfirmHandler = () => {
    mutate(_id);
  };

  return (
    <Box>
      <Typography>¿Confirmas que deseas desactivar a este paciente?</Typography>
      <Box mt={2} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirmHandler}
          loading={isLoading}
        >
          Confirmar
        </Button>
      </Box>
    </Box>
  );
};

export default InactivatePatientConfirmation;
